import {
    DesignTokens,
    GivelifyButton,
    GivelifyFormRadio,
    GivelifyFormRadioProps,
    GivelifyIcon,
    GivelifyLabel,
    GivelifyModal,
} from '@givelify/ui';
import { styled } from '@mui/material';
import { FormShowEnvelope } from './types';

export const ModalTitle = styled('div')(({ theme }) => ({
    textAlign: 'center',
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('mobile')]: {
        marginTop: theme.spacing(4),
    },
}));

export const SwitchImage = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('mobile')]: {
        marginTop: theme.spacing(4),
    },
}));

export const SwitchContent = styled('div')(({ theme }) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('mobile')]: {
        marginBottom: theme.spacing(4),
    },
}));

export const SwitchArrowImg = styled(GivelifyIcon)(({ theme }) => ({
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
}));

export const MobileSmallTitle = styled(GivelifyLabel)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        display: 'inline',
    },
}));

export const EditorContainer = styled(GivelifyLabel)(({ theme }) => ({
    padding: theme.spacing(0, 3.5),
    [theme.breakpoints.down('mobile')]: {
        padding: 0,
    },
}));

export const AlwaysRadio = styled(GivelifyFormRadio)<
    GivelifyFormRadioProps<FormShowEnvelope>
>(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        '& .MuiButtonBase-root': {
            paddingLeft: 0,
        },
    },
}));

export const SpecificDate = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginTop: 16,
    [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
}));

export const SelectDate = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    top: -16,
    [theme.breakpoints.down('mobile')]: {
        position: 'static',
        flexWrap: 'wrap',
        marginTop: theme.spacing(3),
    },
}));

export const SelectDateItem = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('mobile')]: {
        marginBottom: theme.spacing(3),
        justifyContent: 'flex-start',
        width: '100%',
    },
}));

export const DateFieldLabelWrapper = styled('div')({
    marginBottom: 26,
});

export const MobileDate = styled(GivelifyLabel)(({ theme }) => ({
    marginRight: '8px',
    [theme.breakpoints.down('mobile')]: {
        minWidth: 45,
        margin: theme.spacing(0, 1.5, 0, 0),
        textTransform: 'capitalize',
    },
}));

export const SwitchBottom = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(10, 0, 6, 0),
    [theme.breakpoints.down('mobile')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: theme.spacing(1),
    },
}));

export const ModalHeader = styled('div')({
    display: 'flex',
    alignItems: 'center',
    boxShadow: DesignTokens.shadow.divider2,
});

export const CancelBtn = styled(GivelifyButton)(({ theme }) => ({
    marginRight: '16px',
    width: '268px',
    [theme.breakpoints.down('mobile')]: {
        order: 1,
        width: '100%',
    },
}));

export const HideEnvelopeBtn = styled(GivelifyButton)(({ theme }) => ({
    width: '268px',
    [theme.breakpoints.down('mobile')]: {
        order: 0,
        width: '100%',
        marginBottom: theme.spacing(3),
    },
}));

export const CloseModal = styled('div')(({ theme }) => ({
    padding: theme.spacing(1),
    borderRight: '1px solid',
    borderRightColor: DesignTokens.color.dividerPrimaryDark,
}));

export const ModalMobileTitle = styled(GivelifyLabel)(({ theme }) => ({
    paddingLeft: theme.spacing(1.5),
}));

export const ShowHideContent = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        padding: theme.spacing(0, 2),
    },
}));

export const ShowHideModal = styled(GivelifyModal)(({ theme }) => ({
    contentModal: {
        [theme.breakpoints.down('mobile')]: {
            borderRadius: 0,
        },
    },
    showHideModal: {
        justifyContent: 'flex-start',
    },
    '& .MuiDialog-container': {
        '& .MuiPaper-root': {
            width: '808px',
            maxWidth: '808px',
            [theme.breakpoints.down('mobile')]: {
                margin: 0,
                padding: 0,
            },
        },
    },
}));
